<div class="wrapper mb-5">
    <div class="row align-items-center m-0" style="padding: 10px;">
        <img class="p-2" src="./assets/icons/arrow.svg">
        <span class="label-title ml-2 mr-3">Editar Limite Alocado</span>
    </div>
    <div class="component-box container-fluid">
        <form *ngIf="loaded" [formGroup]="allocatedBalanceFormGroup" #allocatedBalanceForm="ngForm"
            (ngSubmit)="onSubmit(allocatedBalanceFormGroup.value)" class="col-12">
            <div class="container-fluid pt-4">
                <div class="row">
                    <div class="col-12">
                        <div class="row m-0">
                            <div class="col-lg-6 col-md-6 col-sm-12 py-2">

                                <mat-form-field class="w-100">
                                    <mat-label class="label-required">Nome:</mat-label>
                                    <input matInput formControlName="name" id="name" autocomplete="off">

                                    <mat-error
                                        *ngIf="(form.name.invalid && (form.name.dirty || form.name.touched)) && form.name.errors.required">
                                        Nome é obrigatório!
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-12 py-2">

                                <mat-form-field class="w-100">
                                    <mat-label class="label-required">Centro de custo:</mat-label>
                                    <mat-select formControlName="costCenterId" id="costCenterId">
                                        <mat-option *ngFor="let item of centrosCustosList" [value]="item.centroCustoId">
                                            {{item.nome}}
                                        </mat-option>
                                    </mat-select>

                                    <mat-error
                                        *ngIf="(form.costCenterId.invalid && (form.costCenterId.dirty || form.costCenterId.touched)) && form.costCenterId.errors.required">
                                        Centro de custo é obrigatório!
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-12 py-2">

                                <mat-form-field class="w-100">
                                    <mat-label class="label-required">Produto Principal:</mat-label>
                                    <mat-select formControlName="principalProductId" id="principalProductId">
                                        <ng-container *ngFor="let item of produtosList">
                                            <mat-option *ngIf="item.produtoElegibilidade.produto.produtoCategoria === 7 || item.produtoElegibilidade.produto.produtoCategoria === 8"
                                                [value]="item.produtoElegibilidade.produto.produtoId">
                                                {{item.produtoElegibilidade.produto.descricao}}
                                            </mat-option>
                                        </ng-container>
                                    </mat-select>

                                    <mat-error
                                        *ngIf="(form.principalProductId.invalid && (form.principalProductId.dirty || form.principalProductId.touched)) && form.principalProductId.errors.required">
                                        Produto Principal é obrigatório!
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <!-- <div class="col-lg-6 col-md-6 col-sm-12 py-2">
                                <mat-form-field class="w-100">
                                    <mat-label [class.label-required]="otherProductsRequired">Outros Produtos:</mat-label>
                                    <mat-select formControlName="products" id="products" [multiple]="true" placeholder="Produtos"  (selectionChange)="changeValidation()">
                                        <mat-option *ngFor="let item of produtosList"
                                            [value]="item.produtoElegibilidade.produto.produtoId">
                                            {{item.produtoElegibilidade.produto.descricao}}
                                        </mat-option>
                                    </mat-select>

                                    <mat-error *ngIf="(form.products.invalid && (form.products.dirty || form.products.touched)) && form.products.errors.required">
                                        Um outro produto é obrigatório!
                                    </mat-error>
                                </mat-form-field>
                            </div> -->
                        </div>
                    </div>
                </div>

                <div class="row button-container mt-5 mb-3">
                    <div class="col-12 text-right">
                        <button class="custom-button-full btn-back custom-button-previous" (click)="navigateToList()">
                            Voltar
                        </button>

                        <button type="submit" class="custom-button-full">
                            Editar
                        </button>
                    </div>
                </div>

            </div>
        </form>
    </div>
</div>
